module.exports = __webpack_public_path__ + "static/media/header_bg.8e74ea77.jpg";